<template>
  <div id="app" v-bind:style="{ marginTop:$root.headerHeight + 'px',marginBottom: $root.footerHeight + 'px'}">
    <!-- ヘッダー -->
    <component :is="headerComponentName" @logout="logout" ></component>
    <!-- ページコンテンツ -->
    <div class="page-content pb-5">
      <router-view @InitloggedIn="InitloggedIn" ></router-view>
    </div>
    <!-- フッター -->
    <component :is="footerComponentName" ref="footer" @logout="logout"></component>

    <can-not-operate-within-demo-alert/>

  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import GuestHeader from "components/global/GuestHeader.vue"
  import LoggedInHeader from "components/global/LoggedInHeader.vue"
  import GuestFooter from "components/global/GuestFooter.vue"
  import CanNotOperateWithinDemoAlert from 'components/modal/CanNotOperateWithinDemoAlert.vue'

  import Auth from 'processor/Auth'

  export default {
  name: 'Wrap',
  components: {
    GuestHeader,
    LoggedInHeader,
    GuestFooter,
    CanNotOperateWithinDemoAlert,
  },
  methods:{
    logout(){
      Auth.logout()
        .then((res)=>{
          store.set("token",null)
          if(res.status === "ng"){}
          this.$router.push({ name: 'logout', params: {}})
        })
    },
    InitloggedIn(){
      this.$root.isLoggedInPage = this.$route.matched.some(route => route.meta.isLoggedInPage)
    }
  },
  computed:{
    headerComponentName(){
      return this.$route.matched.some(route => route.meta.isLoggedInPage) ? "LoggedInHeader" : "GuestHeader"
    },
    footerComponentName(){
      return "GuestFooter"
    },
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
  body{
    background: url("~assets/content_bg.png");
  }
  #app {

  }
</style>



// WEBPACK FOOTER //
// Wrap.vue?3f87f110